import React from "react";
import { useStudioT } from "../studio/i18n";
/** Show the analytics disclosure using the app translation layer. */
export const PrivacyNotice = () => {
  const t = useStudioT();
  return (
    <details className="drawola-analytics-privacy">
      <summary>{t("analytics.privacyTitle")}</summary>
      <p>{t("analytics.privacyBody")}</p>
    </details>
  );
};
